<template>
  <div class>
    <div
      class="
        page-effect
        RegEvent-wrapper
        edu-rage
        event_list_reg
        ss-pre-ev-list
      "
    >
      <section class="reg-event-banner text-center">
        <h1 class="mt-2" v-if="pageHeaderText">{{ pageHeaderText }}</h1>
        <h1 class="mt-2" v-else>Explore Events</h1>
        <!--search box start-->
        <div class="event_Search new_common_search position-relative">
          <input
            v-model="searchText"
            class="search-events-input"
            placeholder="Search Live/Upcoming Events by Name"
          />
          <div v-if="searchText != ''" class="reset-search-btn">
            <p @click="searchText = ''">
              <v-icon dark small color="#8a8a8a">mdi-close</v-icon>
            </p>
          </div>
          <button aria-label="search for events" class="search-submit-button">
            <svg
              width="20"
              height="20"
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.25 8.30362L11.9167 10.9735C12.0358 11.106 12.0299 11.3087 11.9033 11.4341L11.4367 11.9013C11.3741 11.9645 11.2889 12 11.2 12C11.1111 12 11.0259 11.9645 10.9633 11.9013L8.29666 9.2314C8.22291 9.1575 8.15597 9.07707 8.09666 8.99111L7.59666 8.32364C6.76937 8.98506 5.74203 9.34518 4.68333 9.34487C2.50174 9.35245 0.606014 7.84573 0.118485 5.71674C-0.369044 3.58774 0.681736 1.40466 2.64873 0.459942C4.61573 -0.484772 6.97398 0.0610084 8.32733 1.77417C9.68068 3.48732 9.66795 5.91064 8.29666 7.60945L8.96333 8.07C9.06744 8.13672 9.16362 8.21509 9.25 8.30362ZM1.35 4.67255C1.35 6.51572 2.84238 8.0099 4.68333 8.0099C5.56739 8.0099 6.41523 7.65829 7.04035 7.03241C7.66548 6.40654 8.01667 5.55767 8.01667 4.67255C8.01667 2.82938 6.52428 1.3352 4.68333 1.3352C2.84238 1.3352 1.35 2.82938 1.35 4.67255Z"
                fill="currentcolor"
              ></path>
            </svg>
          </button>
        </div>
        <!--search box end-->
      </section>
      <section class="event-box-list-wrapper">
        <div class="container-fluid">
          <!-- <ShareNetwork
            network="facebook"
            url="https://news.vuejs.org/issues/180"
            title="Say hi to Vite! A brand new, extremely fast development setup for Vue."
            description="This week, I’d like to introduce you to 'Vite', which means 'Fast'. It’s a brand new development setup created by Evan You."
            quote="The hot reload is so fast it\'s near instant. - Evan You"
            hashtags="vuejs,vite"
          >
            Share on Facebook
          </ShareNetwork> -->

          <!-----filter-area-->
          <div v-if="EnableEventFilter" class="ev-filt-wrap border">
            <div class="row my-0">
              <div class="col">
                <div class="form-group">
                  <label class="popup-label">Select from date</label>
                  <!-- <input
                    type="date"
                    class="form-control text-uppercase"
                    placeholder="Select from date"
                    v-model="filterDateFrom"
                  /> -->
                  <flat-pickr
                    placeholder="MM/DD/YYYY"
                    class="form-control text-uppercase"
                    name="fromDate"
                    v-model="filterDateFrom"
                    :config="configdateTimePickerStart"
                  />
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label class="popup-label">Select to date</label>
                  <!-- <input
                    type="date"
                    class="form-control text-uppercase"
                    placeholder="Select to date"
                    :min="filterDateFrom"
                    v-model="filterDateTo"
                  /> -->
                  <flat-pickr
                    placeholder="MM/DD/YYYY"
                    class="form-control text-uppercase"
                    name="toDate"
                    v-model="filterDateTo"
                    :config="configdateTimePickerEnd"
                  />
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label class="popup-label">Region</label>
                  <!-- {{ regions }} -->
                  <select class="form-control" v-model="filterRegion">
                    <!-- <option>Select Region</option>
                    <option>Region1</option>
                    <option>Region2</option> -->
                    <option
                      v-for="(item, index) in regions"
                      :key="index"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col d-none">
                <div class="form-group">
                  <label class="popup-label">Type</label>
                  <select class="form-control" v-model="filterType">
                    <option value="">All</option>
                    <option value="free">Free</option>
                    <option value="paid">Paid</option>
                  </select>
                </div>
              </div>
              <div class="col d-none">
                <div class="form-group">
                  <label class="popup-label">Topic</label>
                  <select class="form-control">
                    <option>Select Topic</option>
                    <option>Topic1</option>
                    <option>Topic</option>
                  </select>
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <button
                    :class="
                      advancedSearch
                        ? 'btn btn-primary btn-ev-se cl-filter'
                        : 'btn btn-primary btn-ev-se'
                    "
                    @click="ClearFilter"
                  >
                    {{ SearchButtonText }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-----filter-area end-->
          <div class="row my-0">
            <!-----tab area--->
            <div class="col-md-12 pt-0">
              <h2 class="ev_head mt-6 mb-2">Live/Upcoming Events</h2>
              <!-- <div>{{ startDate }}- {{ endDate }}</div> -->
              <h6 class="session-time-zone mt-md-1 mb-4" style="color: #8b8b8b">
                {{ localTimeZone }}
              </h6>
              <div
                class="
                  ss-session-list-wrapper
                  pb-0
                  justify-content-between
                  d-flex
                "
                style="min-height: 44px"
              >
                <ul
                  v-show="!advancedSearch && RecentFilterTab != ''"
                  role="tablist"
                  class="nav nav-tabs session-nav-tab"
                >
                  <li class="nav-item">
                    <a
                      @click="RecentFilterTab = 'today'"
                      :class="
                        RecentFilterTab == 'today'
                          ? 'nav-link active'
                          : 'nav-link'
                      "
                    >
                      Today
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      @click="RecentFilterTab = 'week'"
                      :class="
                        RecentFilterTab == 'week'
                          ? 'nav-link active'
                          : 'nav-link'
                      "
                    >
                      This Week
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      @click="RecentFilterTab = 'month'"
                      :class="
                        RecentFilterTab == 'month'
                          ? 'nav-link active'
                          : 'nav-link'
                      "
                    >
                      This Month
                    </a>
                  </li>
                </ul>
                <ul
                  v-if="!advancedSearch && RecentFilterTab == ''"
                  role="tablist"
                  class="nav nav-tabs session-nav-tab"
                >
                  <li class="nav-item">
                    <a
                      class="nav-link ev-sback1"
                      @click="RecentFilterTab = 'today'"
                      ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="17.94"
                        viewBox="0 0 22 17.94"
                      >
                        <path
                          id="back.svg"
                          d="M5684,1118.96h-17.45l7.16,6.31a0.96,0.96,0,0,1,0,1.38,0.978,0.978,0,0,1-1.38,0l-8.95-7.93a0.247,0.247,0,0,1-.09-0.04,1.053,1.053,0,0,1,0-1.43,0.631,0.631,0,0,0,.09-0.04l8.95-7.93a0.978,0.978,0,0,1,1.38,0,0.96,0.96,0,0,1,0,1.38l-7.16,6.31H5684A1,1,0,1,1,5684,1118.96Z"
                          transform="translate(-5663 -1109)"
                          class="cls-1"
                        ></path>
                      </svg>
                      All Events
                    </a>
                  </li>
                </ul>
                <!----->
                <button
                  v-if="!advancedSearch && RecentFilterTab != ''"
                  @click="
                    RecentFilterTab = '';
                    filterDateFrom = '';
                    filterDateTo = '';
                  "
                  class="btn btn-primary btn-view-all"
                >
                  View All
                </button>
                <!----->
              </div>
            </div>
            <!-----tab area end--->
            <div class="tab-content px-3" style="width: 100%">
              <div class="tab-pane in active" style="width: 100%">
                <div class="row">
                  <!-- v-on:click="selectEvent(events.ClientId, events.id, events.Name)" -->
                  <div
                    v-for="events in FilteredRecentEvents"
                    v-bind:key="events.id"
                    v-bind:id="events.id"
                    class="col-md-4 event_list_box_w pb-0"
                  >
                    <div
                      class="ev-box event-list-register-shimmer"
                      @click="
                        selectEvent(
                          events.ClientId,
                          events.id,
                          events.Name,
                          events.ExternalRegistrationLink
                        )
                      "
                    >
                      <div class="ev-box-image-hld">
                        <div class="shimmer-effect">
                          <photo class="shine"></photo>
                        </div>
                        <div class="evb-hld">
                          <img
                            v-bind:src="events.EventLogo"
                            v-bind:alt="events.Name"
                            v-on:load="stopShimmer()"
                          />
                        </div>
                        <h4 class="px-3 mt-4">{{ events.Name }}</h4>
                      </div>
                      <div class="ev-box-des-hld1 p-3 pl-0">
                        <!--<h6>
                  <span>Hosted By:</span>
                  {{ClientName}}
                  </h6>-->
                        <div class="top-right-login">
                          <AddEventToCalendar
                            v-if="EnableAddToCalender"
                            :addToCalendarLabel="events.EventDateStringLabel"
                            :displayLabel="true"
                            :eventTitle="events.Name"
                            :eventStartTimestamp="events.EventStartTimestamp"
                            :eventEndTimestamp="events.EventEndTimestamp"
                          ></AddEventToCalendar>
                          <a v-else class="event-List evnttime_ico">
                            {{ events.EventDateStringLabel }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="no-reg-events2 p-4"
                    v-if="EventsLoaded && FilteredRecentEvents.length == 0 && !searchText"
                  >
                    <h2>There are currently no events to Register.</h2>
                  </div>
                  <div
                    v-else-if="EventsLoaded && FilteredRecentEvents.length == 0 && searchText"
                    class="no-reg-events2 p-4"
                  >
                    <h2>No matches found for your Search</h2>
                  </div>
                </div>
              </div>
            </div>
            <div class="border-top mt-8 full-width"></div>
            <!---most populer start----->
            <!-----tab area--->
            <div class="col-md-12 pt-0">
              <h2 class="ev_head my-6">Past Events</h2>
              <!-- <div
                class="
                  ss-session-list-wrapper
                  pb-0
                  justify-content-between
                  d-flex
                "
              >
                <ul role="tablist" class="nav nav-tabs session-nav-tab">
                  <li class="nav-item">
                    <a data-toggle="tab" href="#Free" class="nav-link active">
                      Free
                    </a>
                  </li>
                  <li class="nav-item">
                    <a data-toggle="tab" href="#Paid" class="nav-link">
                      Paid
                    </a>
                  </li>
                </ul>
                <button class="btn btn-primary btn-view-all">View All</button>
              </div> -->
            </div>
            <!-----tab area end--->
            <div class="tab-content">
              <div class="tab-pane in active">
                <div class="row mx-0">
                  <div
                    v-for="events in PastEvents"
                    v-bind:key="events.id"
                    v-on:click="
                      selectEvent(
                        events.ClientId,
                        events.id,
                        events.Name,
                        events.ExternalRegistrationLink
                      )
                    "
                    v-bind:id="events.id"
                    class="col-md-4 event_list_box_w pb-0"
                  >
                    <div class="ev-box event-list-register-shimmer">
                      <div class="ev-box-image-hld">
                        <div class="shimmer-effect">
                          <photo class="shine"></photo>
                        </div>
                        <div class="evb-hld">
                          <img
                            v-bind:src="events.EventLogo"
                            v-bind:alt="events.Name"
                            v-on:load="stopShimmer()"
                          />
                        </div>
                        <h4 class="px-3 mt-3">{{ events.Name }}</h4>
                      </div>
                      <div class="ev-box-des-hld p-3">
                        <!--<h6>
                          <span>Hosted By:</span>
                          {{ClientName}}
                        </h6>-->

                        <div
                          class="top-right-login"
                          v-if="
                            events.EventStartDateString !=
                            events.EventEndDateString
                          "
                        >
                          <a href class="event-List evnttime_ico">
                            {{ events.EventStartDateString }} to
                            {{ events.EventEndDateString }} &nbsp;
                            <!-- {{ events.EventTimezone }} -->
                          </a>
                        </div>
                        <div class="top-right-login" v-else>
                          <a href class="event-List evnttime_ico">
                            {{ events.EventStartDateString }} &nbsp;
                            <!-- {{ events.EventTimezone }} -->
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--Today end-->
              <!----->
              <!-- <div id="Paid" class="tab-pane fade">Paid</div> -->
              <!----->
            </div>
            <!---most populer end----->
          </div>
        </div>
      </section>
    </div>

    <!-- Admin Login Modal -->

    <!-- Create Event Modal -->

    <!-- Create Event Modal -->
    <!-- New Employee Event -->

    <!-- New Employee Event -->
  </div>
</template>
<script>
// import Router from "vue-router";
// import firebase from "firebase";
import APIs from "@/components/APIInit";
import db from "../components/firebaseInit";
// import firebase from "firebase";
// import axios from "axios";
import AddEventToCalendar from "@/components/AddToCalendar.vue";
import store from "../store";
import router from "../router";
import jQuery from "jquery";
let $ = jQuery;

var self;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
import axios from "axios";
import { bus } from "@/main";
import common from "@/common";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
//import ShareNetwork from "vue-social-sharing";
Vue.use(VueMoment, {
  moment,
});
//Vue.use(ShareNetwork);

var timer;
export default {
  components: {
    AddEventToCalendar,
    flatPickr,
  },
  data() {
    return {
      pageHeaderText: "",
      uid: "",
      noEventLink: "https://e2m.live/",
      EventsLoaded: false,
      EventsData: [],
      clientID: "", //this.$store.getters.getClient[0].id,
      BannerURL: "",
      noEventMessage: false,
      isMobileSearch: false,
      mobileBanner: "",
      desktopBanner: "",
      searchText: "",
      EnableEventFilter: false,
      EnableAddToCalender: false,
      ShowCreateEventButton: false,
      ShowSignInPopup: false,
      advancedSearch: false,
      filterDateFrom: "",
      filterDateTo: "",
      filterRegion: "",
      filterType: "",
      RecentFilterTab: "today",
      startDate: "",
      endDate: "",
      regions: [],
      firstName: "",
      lastName: "",
      emailId: "",
      systemTimeDiff: 0,
      currentTimeS: parseInt(new Date().getTime() / 1000),

      showVerificationLinkSentMessage: false,
      IsSubmitting: false,
      AddToCalendarList: [
        { Name: "Google", Service: "google" },
        { Name: "Apple", Service: "apple" },
        { Name: "Yahoo", Service: "yahoo" },
        { Name: "Outlook", Service: "outlook" },
        { Name: "Download", Service: "stream" },
      ],
      EnableSelfService: false,
      localTimeZone: "",
      configdateTimePickerStart: {
        enableTime: false,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
      },
      configdateTimePickerEnd: {
        minDate: null,
        enableTime: false,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
      },
    };
  },
  computed: {
    hasSession() {
      if (self.uid) {
        return true;
      } else {
        return false;
      }
    },
    RecentEvents() {
      var result = [];
      result = self.EventsData.filter(function (item) {
        if (self.currentTimeS < item.EventEndDate.seconds) {
          return true;
        }
      });
      return result;
    },
    PastEvents() {
      var result = [];
      result = self.EventsData.filter(function (item) {
        if (self.currentTimeS >= item.EventEndDate.seconds) {
          return true;
        }
      });
      result = result.sort(function compare(a, b) {
        return b.EventStartDate.seconds - a.EventStartDate.seconds;
      });
      return result;
    },
    FilteredRecentEvents() {
      var result = [];
      var searchText = self.searchText
        ? self.searchText.trim().toLowerCase()
        : "";
      if (!searchText) {
        result = self.RecentEvents.filter(function () {
          return true;
        });
      } else {
        result = self.RecentEvents.filter(function (item) {
          if (item.Name.toLowerCase().includes(searchText.toLowerCase())) {
            return true;
          }
        });
      }
      if (self.filterDateFrom) {
        let filterDateFrom = new Date(self.filterDateFrom);
        let startSeconds = parseInt(filterDateFrom.getTime() / 1000);
        result = result.filter(function (item) {
          if (startSeconds < item.EventEndDate.seconds) {
            return true;
          }
        });
      }
      if (self.filterDateTo) {
        let filterDateTo = new Date(self.filterDateTo);
        filterDateTo.setDate(filterDateTo.getDate() + 1);
        let endSeconds = parseInt(filterDateTo.getTime() / 1000);
        result = result.filter(function (item) {
          if (endSeconds > item.EventEndDate.seconds) {
            return true;
          }
        });
      }
      if (self.filterRegion) {
        result = result.filter(function (item) {
          if (item.Timezone == self.filterRegion) {
            return true;
          }
        });
      }
      if (
        result.length > 0 &&
        !self.advancedSearch &&
        self.RecentFilterTab != ""
      ) {
        let startSeconds = 0;
        let endSeconds = 0;
        let dt = new Date();
        if (self.RecentFilterTab == "today") {
          let startDate = new Date(
            dt.getFullYear(),
            dt.getMonth(),
            dt.getDate()
          );
          let endDate = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
          endDate.setDate(endDate.getDate() + 1);
          startSeconds = parseInt(startDate.getTime() / 1000);
          endSeconds = parseInt(endDate.getTime() / 1000);
          //  alert(startDate);
          //  alert(endDate);
          self.startDate = startDate;
          self.endDate = endDate;
        } else if (self.RecentFilterTab == "week") {
          let startDate = new Date(
            dt.getFullYear(),
            dt.getMonth(),
            dt.getDate()
          );
          //startDate.setDate(startDate.getDate() - dt.getDay());
          let endDate = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
          endDate.setDate(endDate.getDate() - endDate.getDay() + 7);
          startSeconds = parseInt(startDate.getTime() / 1000);
          endSeconds = parseInt(endDate.getTime() / 1000);
          //alert(new Date().getDay());
          //  alert(startDate);
          //  alert(endDate);
          self.startDate = startDate;
          self.endDate = endDate;
        } else if (self.RecentFilterTab == "month") {
          //let startDate = new Date(dt.getFullYear(), dt.getMonth(), 1);
          let startDate = new Date(
            dt.getFullYear(),
            dt.getMonth(),
            dt.getDate()
          );
          let endDate = new Date(dt.getFullYear(), dt.getMonth(), 1);
          endDate.setMonth(endDate.getMonth() + 1);
          startSeconds = parseInt(startDate.getTime() / 1000);
          endSeconds = parseInt(endDate.getTime() / 1000);
          //alert(new Date().getDay());
          //  alert(startDate);
          //  alert(endDate);
          self.startDate = startDate;
          self.endDate = endDate;
        }
        result = result.filter(function (item) {
          if (self.RecentFilterTab == "") {
            return true;
          } else {
            if (
              (item.EventStartDate.seconds <= startSeconds &&
                item.EventEndDate.seconds >= endSeconds) ||
              (item.EventStartDate.seconds >= startSeconds &&
                item.EventStartDate.seconds < endSeconds) ||
              (item.EventEndDate.seconds > startSeconds &&
                item.EventEndDate.seconds < endSeconds)
            ) {
              return true;
            }
            // if (
            //   (item.EventStartDate.seconds >= startSeconds &&
            //     item.EventStartDate.seconds < endSeconds) ||
            //   (item.EventEndDate.seconds >= startSeconds &&
            //     item.EventEndDate.seconds < endSeconds)
            // ) {
            //   return true;
            // }
          }
        });
      }
      result = result.sort(function compare(a, b) {
        return a.EventStartDate.seconds - b.EventStartDate.seconds;
        //return b.EventStartDate.seconds - a.EventStartDate.seconds;
      });
      //alert(result.length);
      return result;
    },
    SearchButtonText() {
      var result = "Search";
      self.advancedSearch = false;
      if (
        self.filterDateFrom ||
        self.filterDateTo ||
        self.filterRegion ||
        self.filterType
      ) {
        result = "Clear Filter";
        self.advancedSearch = true;
      }
      return result;
    },
  },
  watch: {
    //searchText(val) {
    //  alert(val);
    //},
    filterDateFrom(val) {
      if (val) {
        self.RecentFilterTab = "";
        if (self.filterDateTo) {
          if (self.filterDateFrom > self.filterDateTo) {
            self.filterDateTo = "";
          }
        }
      }
    },
    filterDateTo(val) {
      if (val) {
        self.RecentFilterTab = "";
      }
    },
  },
  beforeCreate() {
    // setTimeout(() => {
    //   setTimeout(() => {
    //     setTimeout(() => {
    //       $("#app").addClass("full-screen");
    //     }, 100);
    //     $("#app").addClass("full-screen");
    //   }, 100);
    //   $("#app").addClass("full-screen");
    // }, 100);
    // $("#app").addClass("full-screen");
    // $("#topmenu").hide();
    // $("#leftmenu").hide();
  },
  beforeDestroy() {
    if (timer) {
      clearInterval(timer);
    }
  },
  created() {
    self = this;
    self.localTimeZone = common.getTimeZoneName();
    self.uid = self.getSessionUserId();
    self.initScreen();
    $(window).resize(function () {
      self.initScreen();
    });
    self.createTimer();
  },
  mounted() {
    document
      .querySelector('meta[name="title"]')
      .setAttribute("content", "this is title meta");
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", "this is description");

    self.regions = [{ label: "Select Region", value: "" }].concat(
      common.getTimeZones()
    );
    self.noEventLink = self.$t("client.registerRoute");

    console.log("routes====", self.$route);

    self.clientID = self.$route.params.c;
    self.pageHeaderText = self.$route.query.page_header;

    //this.clientID = self.$route.params.c;
    /* $("#alleventSec").css("background-size", "cover");
    $("#alleventSec").css("background-color", "none");
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    $("#alleventSec").css(
      "background-image",
      "url(" + obj.branding[0].bg2 + ")"
    );
    $("#alleventSec").css("background-size", "100%");
    //alert(obj.Branding[0].banner)
    $("#imgBanner").attr("src", obj.branding[0].banner);

    $(".clsDynamicColor").css("color", obj.branding[0].bodyTextColor);*/
    // $("#topmenu").hide();
    // $("#leftmenu").hide();
    // var obj = JSON.parse(window.localStorage.getItem("my-app"));
    // this.BannerURL = obj.branding[0].banner;
    /*+++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
    //  self.tid =
    //   this.$route.params.tid == undefined ? "" : this.$route.params.tid;

    //-------------------------GEt client id by host---------------------------------------
    //self.clientID = this.$route.params.c;
    const HOSTURL = process.env.VUE_APP_LOCALHOST_URL_EDU;
    if (location.host.toLowerCase().indexOf("localhost") >= 0) {
      self.hostName = HOSTURL ? HOSTURL : self.LocalhostDomain();
    } else {
      self.hostName = HOSTURL ? HOSTURL : location.host;
    }
    var path;
    //console.log(self.hostName);
    if (this.hostName.toLowerCase().indexOf("uat") > -1) {
      path = "https://resources.e2m.live/uate2monair.appspot.com/";
    } else {
      path = APIs.googleSoragePath;
    }
    axios
      .get(
        path + "OA_UAT%2FClients%2FHosts%2F" + this.hostName + ".json?alt=media"
      )
      .then((res) => {
        if (res && res.data) {
          bus.$emit("EnableHelpChat", "Event", res.data.ClientId);
        }
        self.clientID = res.data.ClientId;
        self.clientName = res.data.ClientName;
        document.title = res.data.ClientName;
        if (
          res.data.clientSettings &&
          res.data.clientSettings.EnableEventFilter
        ) {
          self.EnableEventFilter = res.data.clientSettings.EnableEventFilter;
        }
        if (res.data.clientSettings && res.data.clientSettings.AddToCalender) {
          self.EnableAddToCalender = res.data.clientSettings.AddToCalender;
        }
        if (
          res.data.clientSettings &&
          res.data.clientSettings.ShowCreateEventButton
        ) {
          self.ShowCreateEventButton =
            res.data.clientSettings.ShowCreateEventButton;
        }
        if (
          res.data.clientSettings &&
          res.data.clientSettings.ShowSignInPopup
        ) {
          //self.ShowSignInPopup = res.data.clientSettings.ShowSignInPopup;
        }
        if (
          res.data.EventListAssets &&
          res.data.EventListAssets.banner2048x88
        ) {
          self.desktopBanner = res.data.EventListAssets.banner2048x88;
        }
        if (
          res.data.EventListAssets &&
          res.data.EventListAssets.banner750x103
        ) {
          self.mobileBanner = res.data.EventListAssets.banner750x103;
        }

        if (res.data.EnableSelfService) {
          self.EnableSelfService = res.data.EnableSelfService;
        }
        store.commit("setEnableSelfService", self.EnableSelfService);
        self.initScreen();
        self.EventsData = [];
        if (self.clientID) {
          self.displayEvents();
        }
      });
  },
  methods: {
    createEvent() {
      debugger;
      var headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + self.getSessionToken(),
      };

      var requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: "C1594240425613", //self.clientID,
          eventId: "E1637823584078",
        },
        data: {
          EventFullName: "Test Event DG " + new Date().toString(),
          EventShortName: "Test Event DG " + new Date().toString(),
          EventStartDate: "2021-12-01T00:00:00.000Z",
          EventEndDate: "2021-12-09T00:00:00.000Z",
          TimeZone: "Asia/Calcutta",
        },
      };
      axios
        .post(APIs.CloneEvent, JSON.stringify(requestData), {
          headers: headers,
        })
        .then((response) => {
          debugger;
          // self.IsSubmitting = false;
          // if (response.data.status == 0) {
          //   this.showVerificationLinkSentMessage = true;
          // }

          console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
          debugger;
          //self.IsSubmitting = false;
          console.log("Error:" + error);
        });

      // let config = {
      // 	method: 'post',
      // 	url: 'https://us-central1-e2monair.cloudfunctions.net/e2monair-prd-clone-event',
      // 	headers: {
      // 		'Authorization': 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJodHRwczovL2lkZW50aXR5dG9vbGtpdC5nb29nbGVhcGlzLmNvbS9nb29nbGUuaWRlbnRpdHkuaWRlbnRpdHl0b29sa2l0LnYxLklkZW50aXR5VG9vbGtpdCIsImlhdCI6MTYwNDQwMjU5NCwiZXhwIjoxNjA0NDA2MTk0LCJpc3MiOiJzZXJ2ZXJsZXNzLWZyYW1ld29ya0B1YXRlMm1vbmFpci5pYW0uZ3NlcnZpY2VhY2NvdW50LmNvbSIsInN1YiI6InNlcnZlcmxlc3MtZnJhbWV3b3JrQHVhdGUybW9uYWlyLmlhbS5nc2VydmljZWFjY291bnQuY29tIiwidWlkIjoiMTkxMDAyIiwiY2xhaW1zIjp7InJvbGVzIjpbMTAsMTFdfX0.OJrpkrkLjhVzOD1TLy3ML1MrbxHDLFPIgXSCnxbyHXM1_qXesVSWdby3CSknrEUrO9OXOkJTnW9iJ961peJVGLmZs8gPx5gP_0jE1W-kYRg4QAjVQqjTmA3eOwW9MwiX3W_FrL9fV8WvtgIJqn-WhL1amZQX1b3Hz15bIkBNzZykFlGM14PSR-32I_LAtPOMr2Iu2nMHdkOYFuE63XWHidbxtuT6CBxePd02kICzixwF0cgeqkHjWf8ZHuME7H6KRzOy4z0uxzWx_YFHw-hdJX4VNGJHosXczBYhJlUtl2fEjEdMFkQIqJ2l9IHQ7UibFUhLbjswuli3YHXJ8X31MQ',
      // 		'Content-Type': 'application/json'
      // 	},
      // 	data : data
      // };

      // axios(config)
      // .then((response) => {
      // 	console.log(JSON.stringify(response.data));
      // })
      // .catch((error) => {
      // 	console.log(error);
      // });
    },
    Logout() {
      bus.$emit("clearState", true);
      setTimeout(() => {
        self.uid = self.getSessionUserId();
        //location.reload();
      }, 1000);
    },

    initScreen() {
      if (window.innerWidth > 768) {
        self.isMobileSearch = false;
        self.BannerURL = self.desktopBanner;
      } else {
        self.isMobileSearch = true;
        self.BannerURL = self.mobileBanner;
      }
    },
    createTimer() {
      if (timer) {
        clearInterval(timer);
      }
      axios
        .get(APIs.ServerTimeApi)
        .then((responseData) => {
          var serverTime = new Date(
            responseData.data.data.year,
            responseData.data.data.month - 1,
            responseData.data.data.day,
            responseData.data.data.hour,
            responseData.data.data.min,
            responseData.data.data.sec,
            0
          );
          var offset = serverTime.getTimezoneOffset();
          var clientTime = serverTime.getTime() + offset * -1 * 60000;
          //console.log(serverTime);
          var dtNow = new Date();
          self.systemTimeDiff = parseInt((dtNow.getTime() - clientTime) / 1000);
          //console.log("systemTimeDiff: " + self.systemTimeDiff);
          self.currentTimeS = self.currentTime(self.systemTimeDiff);
          timer = setInterval(function () {
            self.currentTimeS++;
          }, 1000);
        })
        .catch(function (err) {
          self.currentTimeS = parseInt(new Date().getTime() / 1000);
          timer = setInterval(function () {
            self.currentTimeS++;
          }, 1000);
          console.log("getservertime:" + err);
        });
    },
    stopShimmer() {
      $(".shimmer-effect").css("display", "none");
    },
    mob_elist_search() {
      $("#mob_ev_search").css("display", "block");
      $(".mob_search_button").css("opacity", "0 ");
    },

    AddToGoogleCalendar(event) {
      var dtFrom = this.getCalendarDateTime(
        event.EventStartDate.seconds,
        "google"
      );
      var dtTo = this.getCalendarDateTime(event.EventEndDate.seconds, "google");
      //alert(location.host.toLowerCase());
      return (
        "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=" +
        dtFrom +
        "/" +
        dtTo +
        "&text=" +
        event.Name +
        "&details=" +
        event.Name.replace("&", "and") +
        "<br/>To Login Go To " +
        location.origin.toLowerCase()
      );
      //return (
      //  "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=" +
      //  dtFrom +
      //  "/" +
      //  dtTo +
      //  "&text=" +
      //  this.Title +
      //  "&details=" +
      //  this.DescriptionShort.replace("&", "and") +
      //  "<br /><br />To Login <a href='" +
      //  location.origin.toLowerCase() +
      //  "'>Click Here</a>" +
      //  "&location=" +
      //  this.Location
      //);
    },
    AddToCalendar(event, service) {
      let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      var dtFrom = this.getCalendarDateTime(
        event.EventStartDate.seconds,
        service
      );
      var dtTo = this.getCalendarDateTime(event.EventEndDate.seconds, service);
      let body =
        event.Name + "<br/>To Login Go To " + location.origin.toLowerCase();
      var linkUrl =
        "start=" +
        dtFrom +
        "&end=" +
        dtTo +
        "&title=" +
        event.Name +
        "&description=" +
        body +
        "&location=&timezone=" +
        tz.replace("/", "%2F") +
        "&service=" +
        service;
      linkUrl =
        "https://www.addevent.com/dir/?client=amFHciuoCzziVYGDHmDp105401&" +
        linkUrl;
      return linkUrl;
    },
    ClearFilter() {
      self.filterDateFrom = "";
      self.filterDateTo = "";
      self.filterRegion = "";
      self.filterType = "";
      self.advancedSearch = false;
    },
    displayEvents() {
      this.pageIndex++;
      var cnt = 0;
      var listRef = db
        .collection("OA_UAT/ClientList/Clients")
        .doc(self.clientID)
        .collection("Events");
      listRef
        //.where("IsPublished", "==", true)
        .where("EventTypeId", "==", 2)
        .where("AllowRegistration", "==", true)
        //.get()
        .onSnapshot((querySnapshot) => {
          this.EventsData = [];
          if (querySnapshot.docs.length > 0) {
            querySnapshot.forEach((doc) => {
              var data = doc.data();
              if (!data.IsTemplate) {
                cnt++;

                /* this.EventsData.push({
                id: doc.id,
                Name: data.EventFullName,
                EventLogo: data.EventLogo,
                EventStartDate: data.EventStartDate,
                EventEndDate: data.EventEndDate,
                EventCollectionName: data.EventCollectionName,
                EventTypeId: data.EventTypeId,
                EventTimezone: data.TimeZone,
                EventStartDateString: self.formatDate(data.EventStartDate),
                EventEndDateString: self.formatDate(data.EventEndDate)
              });*/
                var obj = new Object();
                obj.id = doc.id;
                obj.ClientId = data.ClientId;
                obj.Name = data.EventFullName;
                obj.IsPublished = data.IsPublished;
                obj.EventLogo = data.EventLogo;
                // obj.EventStartDate = data.EventStartDate;
                // obj.EventEndDate = data.EventEndDate;
                obj.EventCollectionName = data.EventCollectionName;
                obj.EventTypeId = data.EventTypeId;
                obj.EventTimezone = moment.tz.guess(); //data.TimeZone;
                obj.Timezone = data.TimeZone;
                //-------------------------------------------------------------------------------------------
                /* var mZone = moment.tz.guess();
              //obj.EventStartDateString = self.formatDate(data.EventStartDate);
              if (data.TimeZone != mZone) {
                var EventStartDate = self.formatDateTimeZoneWise(
                  data.EventStartDate
                );
                var momnt = moment.tz(EventStartDate, data.TimeZone);
                var strtDate = momnt.clone().tz(moment.tz.guess());
                obj.EventStartDateString = self.GetActualDateFormat(
                  strtDate.format()
                );
              } else {
                obj.EventStartDateString = self.formatDate(data.EventStartDate);
              }*/
                if (!data.EventStartDate) {
                  debugger;
                }
                obj.EventStartTimestamp = data.EventStartDate.seconds;
                obj.EventEndTimestamp = data.EventEndDate.seconds;

                var dateFormat = require("dateformat");
                var dtstrt = new Date(data.EventStartDate.seconds * 1000);
                obj.EventStartDateString = dateFormat(dtstrt, "mmm dd, yyyy");
                // obj.EventStartDateString = moment(dtstrt).format(
                //   " MMMM Do, h:mm a"
                // );
                //self.formatDate(data.EventStartDate);
                //------------------------------------------------------------------------------------------------
                /*if (data.TimeZone != mZone) {
                // obj.EventEndDateString = self.formatDate(data.EventEndDate);
                var EventEndDate = self.formatDateTimeZoneWise(
                  data.EventEndDate
                );
                var momnt2 = moment.tz(EventEndDate, data.TimeZone);
                var endDate = momnt2.clone().tz(moment.tz.guess());
                obj.EventEndDateString = self.GetActualDateFormat(
                  endDate.format()
                );
              } else {
                obj.EventEndDateString = self.formatDate(data.EventEndDate);
              }*/
                var dtend = new Date(data.EventEndDate.seconds * 1000);
                obj.EventEndDateString = dateFormat(dtend, "mmm dd, yyyy"); // self.formatDate(data.EventEndDate);
                obj.EventStartDate = data.EventStartDate;
                obj.EventEndDate = data.EventEndDate;
                obj.EventDateStringLabel =
                  obj.EventStartDateString != obj.EventEndDateString
                    ? obj.EventStartDateString + " to " + obj.EventEndDateString
                    : obj.EventStartDateString;

                if (data.ExternalRegistrationEnabled) {
                  obj.ExternalRegistrationLink = data.ExternalRegistrationLink;
                }

                //------------------------------------------------------------------------------------------------
                self.EventsData.push(obj);
              }
            });
            self.noEventMessage = self.EventsData.length > 0 ? false : true;
            // self.EventsData = self.EventsData.sort(function compare(a, b) {
            //   //parseInt(new Date(events[i].EventStartDateTime).getTime() / 1000)
            //   // var dateA = parseInt(
            //   //   new Date(a.EventStartDate.seconds * 1000).getTime() / 1000
            //   // );
            //   // var dateB = parseInt(
            //   //   new Date(b.EventStartDate.seconds * 1000).getTime() / 1000
            //   // );
            //   return b.EventStartDate.seconds - a.EventStartDate.seconds;
            // });
            if (cnt == 1) {
              //router.push({
              //  path:
              //    "/event/" +
              //    this.EventsData[0].id +
              //    "/" +
              //    this.EventsData[0].Name
              //});
              router.push({
                path: "/eventv3/" + this.EventsData[0].id,
              });
            }
          } else {
            self.noEventMessage = true;
          }
          self.EventsLoaded = true;
        });
      // .catch(error => {
      //   alert(error);
      //   // console.log("Error getting documents: ", error);
      // });
    },
    GetActualDateFormat: function (actualDt) {
      var dt = actualDt.split("T");
      var oDt = new Date(dt[0]).toDateString();

      var oTt = dt[1];
      var arrDate = oDt.split(" ");
      var accDate = arrDate[1] + " " + arrDate[2];

      var arrtime = oTt.split(":");
      var accTime = arrtime[0] + ":" + arrtime[1];

      var fullStartDate = accDate + " " + accTime;
      return fullStartDate;
    },
    formatDateTimeZoneWise: function (seconds) {
      var dateString = "";
      try {
        var dt = new Date(seconds.seconds * 1000);
        var hrs = dt.getHours();
        hrs = hrs == 0 ? "00" : hrs;
        if (hrs != "00" && parseInt(hrs) < 10) {
          hrs = "0" + hrs;
        }

        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }

        var mnths = dt.getMonth();
        var accurateMon = mnths + 1;
        if (parseInt(accurateMon) < 10) {
          accurateMon = "0" + accurateMon;
        }

        dateString +=
          dt.getFullYear() +
          "-" +
          accurateMon +
          "-" +
          dt.getDate() +
          " " +
          hrs +
          ":" +
          minutes;

        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    selectEvent: function (clientId, eventId, evntName, regsiterLink) {
      console.log("evntName:--- " + evntName);
      if (regsiterLink) {
        //window.open(regsiterLink, '_blank');
        //window.location(regsiterLink, "_blank");
        location.href = regsiterLink;
      } else {
        var selfServiceFlag = false;
        if (self.EnableSelfService) {
          var uid = self.getSessionUserId();
          var eid = self.getEventId();
          if (uid && eid != eventId) {
            var isAdmin = self.hasEventAdminRole(eventId);
            if (isAdmin) {
              selfServiceFlag = true;
            }
          }
        }
        if (selfServiceFlag) {
          self.ChangeCurrentEvent(clientId, eventId, true);
        } else {
          router.push({
            path: "/eventv3/" + eventId,
          });
        }
      }
    },
    formatDate: function (seconds) {
      var dateString = "";
      //  alert(seconds);
      // if (seconds == 1594125120) {
      //   debugger;
      // }
      try {
        var dt = new Date(seconds.seconds * 1000);
        const monthNamesShort = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        var minutes = dt.getMinutes();
        minutes = minutes == 0 ? "00" : minutes;
        if (minutes != "00" && parseInt(minutes) < 10) {
          minutes = "0" + minutes;
        }
        dateString +=
          dt.getDate() +
          " " +
          monthNamesShort[dt.getMonth()] +
          " " +
          dt.getHours() +
          ":" +
          minutes;
        //return dt.toLocaleDateString();
      } catch (ex) {
        console.log(ex);
      }
      return dateString;
    },
    getCalendarDateTime: function (s, option) {
      var dt = new Date(s * 1000);
      var day = dt.getDate();
      var month = dt.getMonth() + 1;
      var year = dt.getFullYear();
      if (month < 10) {
        month = "0" + month.toString();
      }
      if (day < 10) {
        day = "0" + day.toString();
      }
      var hours = dt.getHours();
      if (hours < 10) {
        hours = "0" + hours.toString();
      }
      var minutes = dt.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes.toString();
      }
      var seconds = dt.getSeconds();
      if (seconds < 10) {
        seconds = "0" + seconds.toString();
      }
      //var amPM = hours < 12 || hours == 0 ? "AM" : "PM";
      //hours = hours > 12 ? hours - 12 : hours;
      //hours = hours == 0 ? 12 : hours;
      //minutes = minutes == 0 ? "00" : minutes > 9 ? minutes : "0" + minutes;
      //seconds = seconds == 0 ? "00" : seconds > 9 ? seconds : "0" + seconds;
      var formattedValue = "";
      if (option == "google") {
        formattedValue =
          year.toString() +
          month.toString() +
          day.toString() +
          "T" +
          hours.toString() +
          minutes.toString() +
          seconds.toString();
      } else {
        //formattedValue =
        //  year.toString() +
        //  "-" +
        //  month.toString() +
        //  "-" +
        //  day.toString() +
        //  "T" +
        //  hours.toString() +
        //  ":" +
        //  minutes.toString() +
        //  ":" +
        //  seconds.toString();
        //12%2F18%2F2020+11%3A00+AM
        //alert(hours);
        //alert(minutes);
        formattedValue =
          year.toString() +
          "%2F" +
          month.toString() +
          "%2F" +
          day.toString() +
          "+";

        if (hours < 10) {
          formattedValue += hours.toString() + "%3A";
        } else {
          if (hours <= 12) {
            formattedValue += hours.toString() + "%3A";
          } else {
            formattedValue += (hours - 12).toString() + "%3A";
          }
        }

        if (minutes < 10) {
          formattedValue += minutes.toString() + "+";
        } else {
          formattedValue += minutes.toString() + "+";
        }

        if (hours < 12) {
          formattedValue += "AM";
        } else {
          formattedValue += "PM";
        }
        //"+" +
        //  "10" + //hours.toString() +
        //  "%3A" +
        //  "10+AM"; //minutes.toString();
        //alert(formattedValue);
      }
      return formattedValue;
    },
    /* ,
    computed: {
      BannerURL() {
        // var obj = JSON.parse(window.localStorage.getItem("my-app"));
        // return obj.branding[0].banner;
        //  db.collection("OA_UAT")
        //         .doc("ClientList")
        //         .collection("Clients")
        //         .where("CustomDomain", "==", this.result)
        //         .get()
        //         .then(querySnapshot => {
        //           querySnapshot.forEach(doc => {
        //           });
        //         });
      },
      pageBg() {
        var obj = JSON.parse(window.localStorage.getItem("my-app"));
        return obj.EventBranding[0].bg2;
      }
    }*/
  },
};
</script>
<style>
.no-reg-events {
  margin: 0 auto;
  text-align: center;
}
.no-reg-events h3 {
  font-weight: 700;
  font-size: 30px;
  color: #333;
  margin-bottom: 25px;
}
.no-reg-events a {
  display: inline-block;
  padding: 8px 30px;
  background: #00a982;
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  border-radius: 5px;
  box-shadow: 0 5px 0 rgba(0, 0, 0, 0.5);
  margin-top: 15px;
}
.no-reg-events a:active {
  transform: translateY(5px);
  box-shadow: none;
}
.event-list-register-shimmer photo {
  display: block;
  width: 100%;
  height: 88px;
}
.shine {
  background: #f6f7f8;
  background-image: linear-gradient(
    to right,
    #f6f7f8 0%,
    #edeef1 20%,
    #f6f7f8 40%,
    #f6f7f8 100%
  );
  background-repeat: no-repeat;
  background-size: 800px 100%;
  display: inline-block;
  position: relative;

  -webkit-animation-duration: 1s;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: infinite;
  -webkit-animation-name: placeholderShimmer;
  -webkit-animation-timing-function: linear;
}
.top-right-login.hdr-btn {
  padding: 0 0 15px;
}
.top-right-login.hdr-btn a.login,
.top-right-login.hdr-btn a.event-List {
  font-size: 18px;
  padding-right: 0 !important;
  margin-left: 25px;
  cursor: pointer;
  background-position: left center;
}
.left-logo.edu-banner {
  width: 100% !important;
}
.event-box-list-wrapper .ev-box {
  cursor: pointer;
}
section.event-box-list-wrapper {
  margin-top: 25px;
}
@media only screen and (max-width: 767px) {
  /* .left-logo.edu-banner {
  display: none;
} */
  .left-logo.edu-banner a {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .left-logo.edu-banner a img {
    width: 100%;
    height: 100%;
  }
  .reg-event-banner {
    padding: 20px 0 !important;
    margin-top: 24px;
  }
  .edu-rage .reg-event-banner h1 {
    margin-top: 0;
  }
}
</style>
